.button {
  appearance: none;
  background: var(--colors-grays-white);
  border: 1px solid var(--colors-grays-light);
  border-radius: var(--border-radius-lg);
  color: var(--colors-grays-mid);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  margin: 0;
  outline: none;
  padding: 12px 16px;
  min-width: 0;
  max-width: 100%;
  flex-shrink: 1;
}

.button:hover,
.button:focus,
.button:focus-visible {
  background: var(--colors-grays-ultralight);
}

.button:focus-visible {
  border-color: var(--colors-primary-main);
}

.button svg {
  flex-shrink: 0;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  line-height: 24px;
}

@media all and (width > 1076px) {
  .button {
    display: none;
  }
}
